module.exports = __webpack_public_path__ + "static/media/gf.3df37f4a.webp";